import { useState } from 'react';
import type { Dayjs } from 'dayjs';
import { ExpiryDateCalendarModal } from './ExpiryDateCalendar';
import { useUpdateDocumentExpiryDate } from 'hooks/useUpdateDocumentExpiryDate';

interface UseExpiryDateCalendarProps {
  contentId: string;
  currentExpiryAtDate: Dayjs;
}

interface UseExpiryDateCalendarReturn {
  open: () => void;
  modal: React.ReactNode;
}

export const useExpiryDateCalendar = ({ contentId, currentExpiryAtDate }: UseExpiryDateCalendarProps): UseExpiryDateCalendarReturn => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const { updateDocumentExpiryDate } = useUpdateDocumentExpiryDate({
    contentId,
    expiryDate: currentExpiryAtDate,
  });

  const handleResolve = (selectedDate: Dayjs | null) => {
    if (!selectedDate?.isValid()) {
      return;
    }

    updateDocumentExpiryDate.mutate(selectedDate);
  };

  const modal = isCalendarOpen ? (
    <ExpiryDateCalendarModal
      isOpen={isCalendarOpen}
      currentExpiryDate={currentExpiryAtDate}
      onResolve={handleResolve}
      onCancel={() => setIsCalendarOpen(false)}
    />
  ) : null;

  return {
    open: () => setIsCalendarOpen(true),
    modal,
  };
};
